import React from 'react';

export default function Notes({ children }) {
  return (
    <ul>{children}</ul>
  );
}